import React from 'react';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { setSessionStorage } from 'utils/storageUtils';
import { getPageTemplate } from 'utils/common';
import {
  destroyAction,
  getAboundToken,
  postLoginActions,
  postLogoutActions,
} from './AboundUtils';
import { handleAboundSignupChecked } from './redux';

const REINIT_ABOUND_WIDGET_EVENT_NAME = 'reinit_abound_widget';

export function reinitializeAboundWidgets(obj) {
  const initEvent = new Event(REINIT_ABOUND_WIDGET_EVENT_NAME);
  if (typeof obj === 'object' && obj.divId && obj.widgetType) {
    initEvent.customObj = obj;
  }
  window.dispatchEvent(initEvent);
}

class AboundSDK extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sdkLoaded: false,
    };
    this.AboundConfig = {
      widgettypes: [
        {
          widgetType: 'aboudwidget-profile',
          platform: 'web',
          channel: 'TOI',
          ele: 'aboundProfile',
          viewportId: 'TOI',
          ticketIdRequired: true,
        },
        { divId: 'widget-head', widgetType: 'aboudwidget-header' },
        // { divId: 'widget-sticky', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-ATF', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-BTF', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two', widgetType: 'abound-widget-two' },
        // { divId: 'widget-two-vs', widgetType: 'abound-widget-two' },
        // {
        //   divId: 'widget-banner',
        //   widgetType: 'abound-widget-banner',
        //   viewportId: 'TOI',
        //   carousel: true,
        //   platform: this.props.isWapView ? 'msite' : 'web',
        // },
        // {
        //   divId: 'abound-widget-offer-full',
        //   widgetType: 'abound-widget-offer-full',
        //   platform: this.props.isWapView ? 'msite' : 'web',
        // },
      ],
    };
  }

  componentDidMount() {
    this.loadSDK();
  }

  // eslint-disable-next-line class-methods-use-this
  loadSDK() {
    window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
      if (
        ((dataObj.userCountry === 'US' && dataObj.userRegion !== 'CA') ||
          (dataObj.userCountry === 'US' &&
            dataObj.userRegion === 'CA' &&
            dataObj.consentGiven)) &&
        window.location.href.indexOf('/games') === -1
      ) {
        if (
          this.props.handleAboundSignup &&
          typeof this.props.handleAboundSignup === 'function'
        ) {
          this.props.handleAboundSignup(true);
        }
        window.abound_js = (function loadJS(d, sc, cb) {
          const script = document.createElement(sc);
          script.src = __PROD__
            ? 'https://loyalty.joinabound.com/widget/static/dist/js/main.js'
            : 'https://aboundcash-tp-dev.s3.us-east-2.amazonaws.com/static/aboundcash-widget-dev/static/dist/js/main.js';
          script.type = 'text/javascript';
          script.async = true;
          script.onload = cb;
          const node = d.getElementsByTagName('script')[0];
          node.parentNode.insertBefore(script, node);
        })(document, 'script', () => {
          this.setState({ sdkLoaded: true });
          document.addEventListener('abound-widget-clicked', event => {
            const { name, state } = event.detail?.customData || {};
            if (name === 'floating') {
              analyticsWrapper('ga4', {
                event: 'user_click',
                type:
                  state === 'logged-out'
                    ? 'non_registered_user'
                    : 'registered_user',
                category: 'abound',
                label: `floating_nudge`,
              });
            }
          });
          document.addEventListener('header-widget-logout', () => {
            const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
            if (!ssoid) {
              if (
                !this.props.isWapView &&
                typeof this.props.signInUser !== 'undefined'
              ) {
                this.props.signInUser({}, false);
              } else if (this.props.isWapView && this.props.toggleLoginBox) {
                setSessionStorage('ga4EventCategoryValue', 'abound');
                this.props.toggleLoginBox(true);
              }
            }
          });
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    try {
      if (
        prevProps?.userAboundData?.clientToken !==
          this.props?.userAboundData?.clientToken &&
        this.props?.userAboundData?.clientToken !== 'NOT_EXIST'
      ) {
        try {
          this.initialiseTimesPoint();
        } catch (error) {
          console.log('Reinitilization Failed:', error);
        }
      } else if (
        this.state.sdkLoaded &&
        this.props.userData?.isLoggedIn &&
        (this.props.userData?.getMobile() &&
          this.props.userData?.getMobile()?.Verified?.code === '+91')
      ) {
        destroyAction(['all']);
        this.isLoggedIn = false;
      } else if (
        this.state.sdkLoaded &&
        !!prevProps.userData?.isLoggedIn !==
          !!this.props.userData?.isLoggedIn &&
        this.props?.userAboundData?.clientToken
      ) {
        postLoginActions();
        this.isLoggedIn = true;
      }
      if (
        window.__aboundCashWidgetReady &&
        !!prevProps.userData?.isLoggedIn !==
          !!this.props?.userData?.isLoggedIn &&
        !this.props?.userData?.isLoggedIn
      ) {
        if (window.AboundCashWidget) {
          postLogoutActions();
          destroyAction([]);
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
    }
  }

  initialiseTimesPoint(obj) {
    this.a = '';
    const widgettypes = (typeof obj === 'object'
      ? [obj]
      : this.AboundConfig.widgettypes
    ).map(
      item =>
        item.divId === 'widget-banner'
          ? {
              ele: item.divId,
              widgetType: item.widgetType,
              viewportId: item.viewportId,
              platform: item.platform,
              carousel: item.carousel,
              channel: 'TOI',
              ticketIdRequired: true,
              pageName: getPageTemplate(),
            }
          : {
              ele: item.divId,
              widgetType: item.widgetType,
              channel: 'TOI',
              platform: this.props.isWapView ? 'msite' : 'web',
              ticketIdRequired: true,
              pageName: getPageTemplate(),
            },
    );
    const widgettypesTicketIdRequired = {};
    widgettypesTicketIdRequired.widgets = widgettypes.filter(
      item => item.ticketIdRequired,
    );
    widgettypesTicketIdRequired.ticketIdRequired = true;
    widgettypes.widgets = widgettypes.filter(item => !item.ticketIdRequired);
    if (
      typeof window.AboundCashWidget !== 'undefined' &&
      typeof window.AboundCashWidget.init === 'function'
    ) {
      [widgettypesTicketIdRequired, widgettypes].map(item => {
        if (
          !item.ticketIdRequired &&
          item?.widgets &&
          Array.isArray(item.widgets) &&
          item.widgets.length > 0
        ) {
          if (getAboundToken()) {
            this.ticketId = getAboundToken();
            window.AboundCashWidget.init({
              widgets: item.widgets,
              userLoginInfo: {
                ticketId: this.ticketId,
              },
            });
          } else {
            window.AboundCashWidget.init({
              widgets: item.widgets,
            });
          }
        } else if (
          item.ticketIdRequired &&
          getAboundToken() &&
          item?.widgets &&
          Array.isArray(item.widgets) &&
          item.widgets.length > 0
        ) {
          this.ticketId = getAboundToken();
          analyticsWrapper('ga4', {
            event: 'user_shown',
            type: 'profile_screen_call_up',
            category: 'abound',
          });
          window.AboundCashWidget.init({
            widgets: item.widgets,
            userLoginInfo: {
              ticketId: this.ticketId,
            },
          });
        }
        return true;
      });
    }
  }
  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  userAboundData: state.abound ? state.abound.userData : {},
  userData: _get(state, 'login.userData', {}),
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  handleAboundSignup: checked => dispatch(handleAboundSignupChecked(checked)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AboundSDK);
